<template>
  <v-app>
    <v-container>
      <v-card color="card1">
        <v-card-title>Team</v-card-title>
      </v-card>
      <v-card>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              class="ml-2 mr-16"
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Search"
              single-line
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :search="search">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Members list</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="green" to="/createmember">
                  <v-icon left>mdi-plus</v-icon>
                  Add Member
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{item}">
              <v-btn
                icon
                :to='"/members/" + item.id'>
                <v-icon>mdi-information</v-icon>
              </v-btn>
            </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  title: 'Members',
  data () {
    return {
      headers: [
        { text: 'Member ID', value: 'memberid' },
        { text: 'Role', value: 'role' },
        { text: 'Full name', value: 'name' },
        { text: 'Gender', value: 'gender' },
        { text: 'Work Location', value: 'location' },
        { text: 'Email Address', value: 'email' },
        { text: 'Contact Number', value: 'contact' },
        { text: 'Actions', value: 'actions' }
      ],
      search: ''
    }
  },
  computed: {
    items () {
      return this.$store.getters.loadedMembers
    },
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>
